import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import modalify from '../modalify';
import styles from './styles.scss';

function OrderHelpIframe({ iframeUrl, title, hasTransparentIframeBackground }) {
  return (
    <iframe
      title={title}
      className={classnames(styles.iframe, {
        [styles.backgroundless]: hasTransparentIframeBackground,
      })}
      src={iframeUrl}
      allowFullScreen
      frameBorder="0"
    />
  );
}

OrderHelpIframe.defaultProps = {
  hasTransparentIframeBackground: false,
};

OrderHelpIframe.propTypes = {
  iframeUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  hasTransparentIframeBackground: PropTypes.bool,
};

const OrderHelpIframeModal = modalify(OrderHelpIframe);

export { OrderHelpIframe, OrderHelpIframeModal };
